import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Search, Mail, Phone, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AdminMessages() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try { const { data } = await api.get("/admin/contacts"); setItems(data || []); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const filtered = items.filter(m => !q || [m.name, m.email, m.subject, m.message, m.phone].some(v => String(v || "").toLowerCase().includes(q.toLowerCase())));

  return (
    <div>
      <div className="flex items-start justify-between flex-wrap gap-4">
        <div>
          <span className="eyebrow-bar"><span className="overline">Inbox</span></span>
          <h1 className="font-display text-3xl font-extrabold mt-2 text-navy">Contact messages</h1>
          <p className="text-sm text-ink-muted mt-1">Submissions from the public contact form.</p>
        </div>
        <Button data-testid="messages-refresh" variant="outline" className="rounded-full" onClick={load}>
          <RefreshCw className="h-4 w-4 mr-2"/>Refresh
        </Button>
      </div>

      <div className="mt-6 card-flat p-4">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-ink-muted"/>
          <Input data-testid="messages-search" value={q} onChange={e=>setQ(e.target.value)} placeholder="Search by name, email, subject…" className="pl-9 rounded-full"/>
        </div>

        <div className="mt-5 space-y-3" data-testid="messages-list">
          {loading && <div className="py-8 text-center text-ink-muted">Loading…</div>}
          {!loading && filtered.length === 0 && <div className="py-12 text-center text-ink-muted">No messages yet.</div>}
          {filtered.map(m => (
            <div key={m.id} className="rounded-2xl border border-slate-200 p-5 hover:border-saffron transition-colors">
              <div className="flex items-start justify-between gap-3 flex-wrap">
                <div>
                  <div className="font-display font-bold text-lg text-navy">{m.name}</div>
                  <div className="text-xs text-ink-muted">{new Date(m.created_at).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" })}</div>
                </div>
                <div className="flex gap-3 text-sm">
                  {m.email && <a href={`mailto:${m.email}`} className="inline-flex items-center gap-1.5 text-navy hover:text-saffron"><Mail className="h-4 w-4"/>{m.email}</a>}
                  {m.phone && <a href={`tel:${m.phone}`} className="inline-flex items-center gap-1.5 text-navy hover:text-saffron"><Phone className="h-4 w-4"/>{m.phone}</a>}
                </div>
              </div>
              {m.subject && <div className="mt-3 font-semibold text-sm">{m.subject}</div>}
              <div className="mt-2 text-sm text-ink-muted whitespace-pre-wrap">{m.message}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
